import { createTheme } from "@mui/material";

export default createTheme({
    palette: {
        primary: {
            light: "#019BBE20",
            main: "#019BBE",
            dark: "#017C98",
        },
        warning: {
            light: "#F49E0020",
            main: "#EC6E0C",
            dark: "#bd5809",
        },
    },
    components: {
        MuiTable: {
            styleOverrides: {
                root: {
                    border: "solid 1px #000",
                },
            },
        },
        MuiFormControl: {
            styleOverrides: {
                root: {
                    ".MuiInputBase-adornedEnd .Mui-readOnly ": {
                        border: "solid 1px #000",
                    },
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    background: "#fff",
                },
            },
        },
    },
});
